import { urlControlPanel, urlUserList } from '@/urls';
import { useCurrentClub } from '@/hooks/use-current-club';
import type { ClubManager } from '@repo/shared-types';
import { Tag } from '@repo/ui/components/tag';
import { DataTable } from '@repo/ui/components/data-table';

const columns = [
  {
    header: 'Email',
    accessorKey: 'user.email',
  },
  {
    header: 'Rol',
    accessorKey: 'role',
    cell: ({ row }: { row: { original: ClubManager } }) => {
      return <Tag>{row.original.role}</Tag>;
    },
  },
];

function UserList() {
  const club = useCurrentClub();

  return <DataTable columns={columns} data={club.members} total={club.members.length} />;
}

export const route = {
  path: urlUserList(':id'),
  element: <UserList />,
  handle: {
    title: 'Usuarios',
    backLink: (params: { id: string }) => urlControlPanel(params.id),
  },
};
